/**
 * `sectionGapMobile` and `sectionGapDesktop` are vertical.
 * Each section "owns" the gap BELOW itself.
 */
export const sectionGapMobile = 40
export const sectionGapDesktop = 100
export const sectionSideGapDesktop = 120 // when not full-bleed
